/* Imports */
import React from 'react'

/* MobileHeading Functional Component */
function MobileHeading(props) {
  return (
    <span className='text-sm text-white capitalize mt-3 font-semibold'>{props.text}</span>
  )
}

/* Exports Component */
export default MobileHeading